import { render, staticRenderFns } from "./Port.vue?vue&type=template&id=92127c08&scoped=true"
import script from "./Port.vue?vue&type=script&lang=js"
export * from "./Port.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92127c08",
  null
  
)

export default component.exports